<template>
    <div class="empty">
        <img class="empty-image" src="../../../assets/image/jiaxing/empty.png" alt />
        <div class="empty-text">暂无资料催收信息</div>
    </div>
</template>

<script>
  export default {
    name: "index"
  };
</script>

<style scoped>
    .empty {
        display: flex;
        flex-direction: column;
        padding-top: 100px;
        width: 100%;
        justify-content: center;
        align-items: center;
    }
    .empty-image {
        width: 240px;
        height: 240px;
        margin-bottom: 20px;
    }
    .empty-text {
        color: #999999;
        font-size: 16px;
    }
</style>
